<div class="min-h-screen dark:bg-slate-900 p-4 md:p-8 text-sm text-slate-600 dark:text-slate-300">
  <div class="animate-fade-in flex flex-col md:flex-row md:items-end justify-between mb-8 gap-4">
    <div>
      <h1 class="text-3xl font-extrabold text-slate-800 dark:text-slate-100 tracking-tight">ประวัติการชำระเงิน</h1>
      <p class="text-slate-500 dark:text-slate-400 mt-2 font-medium">ตรวจสอบ Payment Log ของลานจอดรถแบบอ่านอย่างเดียว</p>
    </div>
    <div class="flex flex-col sm:flex-row gap-3 items-stretch sm:items-center self-start">
      <div
        class="flex items-center gap-2 px-3 py-2 bg-slate-50 dark:bg-slate-800/50 rounded-xl border border-slate-100 dark:border-slate-700 focus-within:bg-white dark:focus-within:bg-slate-800 focus-within:ring-2 focus-within:ring-amber-200 transition-all shadow-sm h-[46px]">
        <span class="material-icons text-slate-400 text-xl">calendar_today</span>

        <div class="relative w-[130px] h-full flex items-center">
          <div
            class="absolute inset-0 flex items-center justify-between px-3 font-bold text-sm text-slate-600 dark:text-slate-300 pointer-events-none">
            <span>{{ startDate() | date:'dd/MM/yyyy' }}</span>
            <span class="material-icons text-slate-400 text-lg">expand_more</span>
          </div>
          <input #startDatePicker type="date" [ngModel]="startDate()"
            (ngModelChange)="startDate.set($event); onDateChange()" [max]="endDate()"
            (click)="startDatePicker.showPicker()"
            class="opacity-0 w-full h-full cursor-pointer z-10 border-none p-0 focus:ring-0 [color-scheme:light] dark:[color-scheme:dark]" />
        </div>

        <span class="text-slate-300 dark:text-slate-600">-</span>

        <div class="relative w-[130px] h-full flex items-center">
          <div
            class="absolute inset-0 flex items-center justify-between px-3 font-bold text-sm text-slate-600 dark:text-slate-300 pointer-events-none">
            <span>{{ endDate() | date:'dd/MM/yyyy' }}</span>
            <span class="material-icons text-slate-400 text-lg">expand_more</span>
          </div>
          <input #endDatePicker type="date" [ngModel]="endDate()"
            (ngModelChange)="endDate.set($event); onDateChange()" [min]="startDate()"
            (click)="endDatePicker.showPicker()"
            class="opacity-0 w-full h-full cursor-pointer z-10 border-none p-0 focus:ring-0 [color-scheme:light] dark:[color-scheme:dark]" />
        </div>
      </div>

      <span class="text-xs text-slate-400 whitespace-nowrap">
        ดึงข้อมูลล่าสุด:
        <strong class="text-slate-600 dark:text-slate-300">
          {{ lastFetchedAt() ? (lastFetchedAt() | date:'HH:mm:ss') : 'ยังไม่ได้ดึงข้อมูล' }}
        </strong>
      </span>
      <button (click)="onRefresh()" title="ดึงข้อมูล"
        class="px-4 py-3 bg-white/95 dark:bg-slate-800/95 text-slate-500 rounded-2xl shadow-sm border border-slate-100/50 dark:border-slate-700 hover:text-amber-500 hover:shadow-md transition-all flex items-center gap-2 cursor-pointer">
        <span class="material-icons">refresh</span>
        <span class="font-bold">ดึงข้อมูล</span>
      </button>
    </div>
  </div>
  <div class="animate-fade-in bg-white/95 dark:bg-slate-800/95 rounded-[2rem] shadow-[0_20px_50px_rgba(0,0,0,0.04)] border border-slate-100/50 dark:border-slate-700/50 overflow-hidden">
    <div class="p-6 border-b border-slate-100/70 dark:border-slate-700">
      <div class="flex flex-col lg:flex-row lg:items-center justify-between gap-4">
        <div>
          <h3 class="text-lg font-bold text-slate-800 dark:text-slate-100 flex items-center gap-2">
            <span class="material-icons text-amber-500">receipt_long</span>รายการ Payment Log
          </h3>
          <span *ngIf="siteState.selectedSite()?.name"
            class="inline-flex items-center gap-1 mt-2 px-2.5 py-1 rounded-full bg-amber-50 dark:bg-amber-900/20 text-amber-600 dark:text-amber-400 text-xs font-bold">
            <span class="material-icons text-[14px]">local_parking</span>{{ siteState.selectedSite()?.name }}
          </span>
        </div>
        <div class="relative w-full lg:max-w-md">
          <span class="absolute left-3 top-1/2 -translate-y-1/2 material-icons text-slate-400 text-[20px]">search</span>
          <input type="text" [ngModel]="searchText()" (ngModelChange)="searchText.set($event); onSearchChange()"
            placeholder="ค้นหา Ticket, Order, Pay Ref หรือ Email..."
            class="w-full pl-10 pr-4 py-2.5 bg-slate-50 dark:bg-slate-900 rounded-xl border border-slate-100 dark:border-slate-700 text-sm font-medium focus:ring-2 focus:ring-amber-200 focus:outline-none" />
        </div>
      </div>
    </div>
    <div class="overflow-x-auto min-h-[300px] relative custom-scrollbar">
      <app-pss-loading *ngIf="isLoading()"></app-pss-loading>
      <table class="w-full text-left border-collapse" [class.opacity-50]="isLoading()">
        <thead class="sticky top-0 z-20 bg-white/95 dark:bg-slate-800/95 border-b border-slate-100 dark:border-slate-700">
          <tr class="text-xs font-bold text-slate-400 uppercase tracking-widest">
            <th class="p-4">ID</th>
            <th class="p-4">Ticket</th>
            <th class="p-4">Merchant Order</th>
            <th class="p-4 text-right">ยอดเงิน</th>
            <th class="p-4 text-right">Parking Fee</th>
            <th class="p-4">วันที่ชำระ</th>
            <th class="p-4 text-center">สถานะการจ่าย</th>
            <th class="p-4">ประเภท</th>
            <th class="p-4 text-center w-[90px]">ดู</th>
          </tr>
        </thead>
        <tbody class="divide-y divide-slate-50 dark:divide-slate-700">
          <tr *ngFor="let item of items(); trackBy: trackById"
            class="hover:bg-slate-50/60 dark:hover:bg-slate-700/40 transition-all">
            <td class="p-4 font-mono font-bold text-slate-400">{{ item.id }}</td>
            <td class="p-4 font-mono text-xs font-bold text-slate-700 dark:text-slate-200">{{ item.ticketId || '—' }}</td>
            <td class="p-4 font-mono text-xs text-slate-500">{{ item.merchantOrderId || '—' }}</td>
            <td class="p-4 text-right font-black text-emerald-600 dark:text-emerald-400">{{ (item.amount ?? 0) | number:'1.2-2' }} ฿</td>
            <td class="p-4 text-right font-bold">{{ (item.parkingFee ?? 0) | number:'1.2-2' }} ฿</td>
            <td class="p-4 text-xs text-slate-500 whitespace-nowrap">{{ item.payDate ? (item.payDate | date:'dd/MM/yyyy HH:mm') : '—' }}</td>
            <td class="p-4 text-center">
              <span class="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-bold"
                [ngClass]="item.payDate
                  ? 'bg-emerald-50 text-emerald-700 dark:bg-emerald-900/30 dark:text-emerald-400'
                  : 'bg-amber-50 text-amber-700 dark:bg-amber-900/30 dark:text-amber-400'">
                <span class="w-1.5 h-1.5 rounded-full" [ngClass]="item.payDate ? 'bg-emerald-500' : 'bg-amber-500'"></span>
                {{ item.payDate ? 'ชำระแล้ว' : 'รอชำระ' }}
              </span>
            </td>
            <td class="p-4">
              <span class="px-2.5 py-1 rounded-full bg-sky-50 dark:bg-sky-900/20 text-sky-600 dark:text-sky-400 text-xs font-bold">
                {{ item.paymentLogType || '—' }}
              </span>
            </td>
            <td class="p-4 text-center">
              <button (click)="openDetail(item)" title="ดูรายละเอียด"
                class="w-9 h-9 rounded-lg inline-flex items-center justify-center border border-slate-100 dark:border-slate-700 text-slate-400 hover:border-amber-400 hover:text-amber-500 transition-all cursor-pointer">
                <span class="material-icons text-base">visibility</span>
              </button>
            </td>
          </tr>
          <tr *ngIf="!selectedSiteId && !isLoading()">
            <td colspan="9" class="py-20 text-center text-slate-400">
              <span class="material-icons text-4xl mb-2">location_off</span>
              <p class="font-bold">กรุณาเลือกลานจาก Sidebar</p>
            </td>
          </tr>
          <tr *ngIf="selectedSiteId && !isLoading() && items().length === 0">
            <td colspan="9" class="py-20 text-center text-slate-400">
              <span class="material-icons text-4xl mb-2">search_off</span>
              <p class="font-bold">ไม่พบข้อมูล Payment Log</p>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="px-6 py-4 border-t border-slate-100/70 dark:border-slate-700 flex flex-col md:flex-row items-center justify-between gap-4">
      <div class="flex items-center gap-4 text-sm text-slate-500 font-medium">
        <span>แสดง {{ startItemIndex | number }} - {{ endItemIndex | number }} จาก {{ totalItems() | number }} รายการ</span>
        <select (change)="onPageSizeChange($event)" [ngModel]="pageSize()"
          class="bg-slate-50 dark:bg-slate-800 border border-slate-200 dark:border-slate-700 text-sm rounded-lg font-bold px-2 py-1 outline-none focus:ring-2 focus:ring-amber-200">
          <option *ngFor="let size of pageSizeOptions" [value]="size">{{ size }} / หน้า</option>
        </select>
      </div>
      <div class="flex items-center gap-2">
        <button (click)="setPage(currentPage() - 1)" [disabled]="currentPage() === 1"
          class="w-9 h-9 flex items-center justify-center rounded-lg border border-slate-200 dark:border-slate-700 hover:text-amber-500 disabled:opacity-30 transition-all cursor-pointer">
          <span class="material-icons text-sm">chevron_left</span>
        </button>
        <button *ngFor="let page of pagesArray" (click)="setPage(page)"
          class="w-9 h-9 flex items-center justify-center rounded-lg text-sm font-bold transition-all cursor-pointer"
          [ngClass]="page === currentPage() ? 'bg-amber-400 text-white shadow-sm' : 'text-slate-600 dark:text-slate-300 hover:bg-amber-50 dark:hover:bg-slate-700'">
          {{ page }}
        </button>
        <button (click)="setPage(currentPage() + 1)" [disabled]="currentPage() === totalPages() || totalPages() === 0"
          class="w-9 h-9 flex items-center justify-center rounded-lg border border-slate-200 dark:border-slate-700 hover:text-amber-500 disabled:opacity-30 transition-all cursor-pointer">
          <span class="material-icons text-sm">chevron_right</span>
        </button>
      </div>
    </div>
  </div>
</div>
<div *ngIf="isModalOpen()"
  class="fixed inset-0 z-50 flex items-center justify-center bg-slate-900/60 backdrop-blur-md p-4"
  (click)="closeModal()">
  <div class="bg-white dark:bg-slate-900 w-full max-w-5xl rounded-3xl shadow-2xl overflow-hidden"
    (click)="$event.stopPropagation()">
    <div class="flex items-center justify-between px-6 py-4 border-b border-slate-100 dark:border-slate-800">
      <h2 class="text-lg font-bold">รายละเอียด Payment Log #{{ selectedId() }}</h2>
      <button (click)="closeModal()" class="material-icons text-slate-400">close</button>
    </div>

    <div *ngIf="isDetailLoading()" class="p-12 text-center text-slate-400">กำลังโหลดรายละเอียด...</div>
    <div class="p-6 max-h-[75vh] overflow-y-auto text-sm" *ngIf="selectedDetail() as d">
      <div class="space-y-6">
        <section>
          <h3 class="mb-3 text-xs font-black uppercase tracking-wider text-amber-500">ข้อมูลอ้างอิง</h3>
          <div class="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-3">
            <div><span class="text-slate-400">ID:</span> {{ d.id }}</div>
            <div><span class="text-slate-400">Ticket ID:</span> {{ d.ticketId || '—' }}</div>
            <div><span class="text-slate-400">Merchant Order ID:</span> {{ d.merchantOrderId || '—' }}</div>
            <div><span class="text-slate-400">Pay Ref:</span> {{ d.payRef || '—' }}</div>
            <div><span class="text-slate-400">QR Code ID:</span> {{ d.qrcodeId || '—' }}</div>
            <div><span class="text-slate-400">Transaction ID:</span> {{ d.transactionId ?? '—' }}</div>
            <div><span class="text-slate-400">Invoice Header ID:</span> {{ d.invoiceHeaderId ?? '—' }}</div>
            <div><span class="text-slate-400">POS ID:</span> {{ d.posId ?? '—' }}</div>
            <div><span class="text-slate-400">Payment Log Type:</span> {{ d.paymentLogType || '—' }}</div>
          </div>
        </section>

        <section class="border-t border-slate-100 dark:border-slate-800 pt-5">
          <h3 class="mb-3 text-xs font-black uppercase tracking-wider text-amber-500">ข้อมูลการชำระเงิน</h3>
          <div class="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-3">
            <div><span class="text-slate-400">สถานะ:</span> {{ d.payDate ? 'ชำระแล้ว' : 'รอชำระ' }}</div>
            <div><span class="text-slate-400">Pay Date:</span> {{ d.payDate ? (d.payDate | date:'dd/MM/yyyy HH:mm:ss') : '—' }}</div>
            <div><span class="text-slate-400">Amount:</span> {{ d.amount !== null ? ((d.amount | number:'1.2-2') + ' ฿') : '—' }}</div>
            <div><span class="text-slate-400">Parking Fee:</span> {{ d.parkingFee !== null ? ((d.parkingFee | number:'1.2-2') + ' ฿') : '—' }}</div>
            <div><span class="text-slate-400">Over Night:</span> {{ d.overNight !== null ? ((d.overNight | number:'1.2-2') + ' ฿') : '—' }}</div>
            <div><span class="text-slate-400">Lost Card:</span> {{ d.lostCard !== null ? ((d.lostCard | number:'1.2-2') + ' ฿') : '—' }}</div>
            <div><span class="text-slate-400">Parking Fee Sub:</span> {{ d.parkingFeeSub !== null ? ((d.parkingFeeSub | number:'1.2-2') + ' ฿') : '—' }}</div>
            <div><span class="text-slate-400">Over Night Sub:</span> {{ d.overNightSub !== null ? ((d.overNightSub | number:'1.2-2') + ' ฿') : '—' }}</div>
            <div><span class="text-slate-400">Email:</span> {{ d.email || '—' }}</div>
          </div>
        </section>

        <section class="border-t border-slate-100 dark:border-slate-800 pt-5">
          <h3 class="mb-3 text-xs font-black uppercase tracking-wider text-amber-500">ลานและบริษัท</h3>
          <div class="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-3">
            <div><span class="text-slate-400">Company ID:</span> {{ d.companyId }}</div>
            <div><span class="text-slate-400">Site ID:</span> {{ d.siteId ?? '—' }}</div>
            <div><span class="text-slate-400">Site Name:</span> {{ d.siteName || '—' }}</div>
          </div>
        </section>

        <section class="border-t border-slate-100 dark:border-slate-800 pt-5">
          <h3 class="mb-3 text-xs font-black uppercase tracking-wider text-amber-500">URL และผลตอบกลับ</h3>
          <div class="space-y-3">
            <div class="break-all"><span class="text-slate-400">URL Success:</span> {{ d.urlSuccess || '—' }}</div>
            <div class="break-all"><span class="text-slate-400">URL Fail:</span> {{ d.urlFail || '—' }}</div>
            <div>
              <span class="text-slate-400">Ksher Return:</span>
              <pre class="mt-2 max-h-56 overflow-auto whitespace-pre-wrap break-all rounded-xl bg-slate-50 p-3 text-xs dark:bg-slate-800">{{ d.ksherReturn || '—' }}</pre>
            </div>
          </div>
        </section>

        <section class="border-t border-slate-100 dark:border-slate-800 pt-5">
          <h3 class="mb-3 text-xs font-black uppercase tracking-wider text-amber-500">Odoo Audit (อ่านอย่างเดียว)</h3>
          <div class="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-3">
            <div><span class="text-slate-400">Message Main Attachment ID:</span> {{ d.messageMainAttachmentId ?? '—' }}</div>
            <div><span class="text-slate-400">Create UID:</span> {{ d.createUid ?? '—' }}</div>
            <div><span class="text-slate-400">Create Date:</span> {{ d.createDate ? (d.createDate | date:'dd/MM/yyyy HH:mm:ss') : '—' }}</div>
            <div><span class="text-slate-400">Write UID:</span> {{ d.writeUid ?? '—' }}</div>
            <div><span class="text-slate-400">Write Date:</span> {{ d.writeDate ? (d.writeDate | date:'dd/MM/yyyy HH:mm:ss') : '—' }}</div>
          </div>
        </section>
      </div>
    </div>

    <div class="px-6 py-4 border-t border-slate-100 dark:border-slate-800 flex justify-end">
      <button (click)="closeModal()" class="px-5 py-2 rounded-xl border">ปิด</button>
    </div>
  </div>
</div>
